import { render } from "./QuickAccess.vue?vue&type=template&id=208ae810&scoped=true"
import script from "./QuickAccess.vue?vue&type=script&lang=js"
export * from "./QuickAccess.vue?vue&type=script&lang=js"

import "./QuickAccess.vue?vue&type=style&index=0&id=208ae810&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ae810"]])

export default __exports__